import { request } from '../request'

export function search(query) {
  return request(`/colors.json?query=${query}`)
}

export function find(id) {
  return request(`/colors/${id}.json`)
}
